<template>
  <b-container class="pb-5">
    <b-row align-h="center">
      <b-col cols="12" md="10" lg="8">
        <div class="py-5 text-center">
          <b-img :src="require('@/assets/images/icon-aircon.svg')"></b-img>
        </div>
        <h1 class="text-center">取付依頼フォーム</h1>
        <p class="text-center my-5 text-muted">
          エアコンの取付を依頼される方は、<br />下記フォームにご入力の上「取付依頼」ボタンを押してください
        </p>
        <b-form-row>
          <b-col cols="12" sm="4" lg="3">
            <label class="h5 font-weight-normal">依頼内容</label>
          </b-col>
          <b-col cols="12" sm="8" lg="7" class="mb-4">
            <PriceTable />
            <b-button :to="{ name: 'page1' }" variant="link" size="lg">
              <svg
                aria-hidden="true"
                focusable="false"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="22"
                viewBox="0 0 192 512"
                class=""
              >
                <path
                  fill="currentColor"
                  d="M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"
                  class=""
                ></path>
              </svg>
              見積シミュレーションページにもどる
            </b-button>
          </b-col>
        </b-form-row>
        <b-form-group
          id="fieldset-name"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="お名前"
          label-size="lg"
          label-for="input-name"
        >
          <b-form-input
            id="input-name"
            size="lg"
            v-model="formData.name"
            class="shadow-inset"
            placeholder="取付 太郎"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="fieldset-kana"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label-size="lg"
          label-for="input-kana"
        >
          <template slot="label"
            >フリガナ<b-badge variant="danger" class="ml-2"
              >必須</b-badge
            ></template
          >
          <b-form-input
            id="input-kana"
            :state="$v.formData.kana.$error ? false : null"
            size="lg"
            v-model="formData.kana"
            class="shadow-inset"
            @input="$v.formData.kana.$touch()"
            placeholder="トリツケ タロウ"
          ></b-form-input>
          <small class="form-text text-danger" v-if="$v.formData.kana.$error">
            必須項目です
          </small>
        </b-form-group>
        <b-form-group
          id="fieldset-zip"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="郵便番号"
          label-size="lg"
          label-for="input-zip"
        >
          <b-form-input
            id="input-zip"
            plaintext
            v-model="formData.zip"
            size="lg"
            class=""
            placeholder="123-4567"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="fieldset-address1"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="都道府県"
          label-size="lg"
          label-for="input-address1"
        >
          <b-form-input
            id="input-address1"
            plaintext
            v-model="formData.address1"
            size="lg"
            class=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="fieldset-address2"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="市区町村"
          label-size="lg"
          label-for="input-address2"
        >
          <b-form-input
            id="input-address2"
            plaintext
            v-model="formData.address2"
            size="lg"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="fieldset-address3"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label-size="lg"
          label-for="input-address3"
        >
          <template slot="label"
            >以下住所<b-badge variant="danger" class="ml-2"
              >必須</b-badge
            ></template
          >
          <b-form-input
            id="input-address3"
            v-model="formData.address3"
            class="shadow-inset"
            size="lg"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="fieldset-address4"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="建物名・部屋番号"
          label-size="lg"
          label-for="input-address4"
        >
          <b-form-input
            id="input-address4"
            v-model="formData.address4"
            class="shadow-inset"
            size="lg"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="fieldset-phone"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label-size="lg"
          label-for="input-phone"
        >
          <template slot="label"
            >電話番号<b-badge variant="danger" class="ml-2"
              >必須</b-badge
            ></template
          >
          <b-form-input
            id="input-phone"
            v-model="formData.tel"
            class="shadow-inset"
            size="lg"
            placeholder="0120-15-4147"
            inputmode="tel"
            :state="$v.formData.tel.$error ? false : null"
            @input="$v.formData.tel.$touch()"
          >
          </b-form-input>
          <small class="form-text text-danger" v-if="$v.formData.tel.$error">
            必須項目です
          </small>
        </b-form-group>
        <b-form-group
          id="fieldset-email"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label-size="lg"
          label-for="input-email"
          inputmode="email"
        >
          <template slot="label"
            >メール<b-badge variant="danger" class="ml-2"
              >必須</b-badge
            ></template
          >
          <b-form-input
            id="input-email"
            v-model="formData.email"
            class="shadow-inset"
            size="lg"
            placeholder="user@aircon-hanbai.jp"
            @input="$v.formData.email.$touch()"
            :state="$v.formData.email.$error ? false : null"
          >
          </b-form-input>
          <small class="form-text text-danger" v-if="$v.formData.email.$error">
            正しい形式ではありません
          </small>
        </b-form-group>
        <b-form-group
          id="fieldset-time"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="9"
          label="電話連絡ご希望時間帯"
          label-size="lg"
          label-for="input-time"
        >
          <b-form-radio-group
            id="input-time"
            v-model="formData.time"
            size="lg"
            class="pt-3"
          >
            <b-form-radio value="いつでも">いつでも</b-form-radio>
            <b-form-radio value="9〜12時">9〜12時</b-form-radio>
            <b-form-radio value="12〜15時">12〜15時</b-form-radio>
            <b-form-radio value="15〜18時">15〜18時</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-row>
          <label
            class="col-12 col-md-4 col-lg-3 col-form-label col-form-label-lg"
            >訪問日程</label
          >
          <b-col cols="12" md="8" lg="7">
            <b-form-group
              id="fieldset-date1"
              label="第一希望"
              label-for="input-date1"
            >
              <b-form-datepicker
                id="input-date1"
                v-model="formData.date1"
                :date-disabled-fn="notAllowedDates1"
                size="lg"
                class="shadow-inset"
                placeholder="選択してください"
                locale="ja"
                :date-format-options="{
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                }"
                @input="$v.formData.date1.$touch()"
                :state="$v.formData.date1.$error ? false : null"
              >
              </b-form-datepicker>
              <small
                class="form-text text-danger"
                v-if="$v.formData.date1.$error"
              >
                必須項目です
              </small>
            </b-form-group>
            <b-form-group
              id="fieldset-date2"
              label="第二希望"
              label-for="input-date2"
            >
              <b-form-datepicker
                id="input-date2"
                v-model="formData.date2"
                :date-disabled-fn="notAllowedDates2"
                size="lg"
                class="shadow-inset"
                placeholder="選択してください"
                locale="ja"
                @input="$v.formData.date2.$touch()"
                :state="$v.formData.date2.$error ? false : null"
                :date-format-options="{
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                }"
              >
              </b-form-datepicker>
              <small
                class="form-text text-danger"
                v-if="$v.formData.date2.$error"
              >
                必須項目です
              </small>
            </b-form-group>
            <b-form-group
              id="fieldset-date3"
              label="第三希望"
              label-for="input-date3"
            >
              <b-form-datepicker
                id="input-date3"
                v-model="formData.date3"
                :date-disabled-fn="notAllowedDates3"
                size="lg"
                class="shadow-inset"
                placeholder="選択してください"
                locale="ja"
                @input="$v.formData.date3.$touch()"
                :state="$v.formData.date3.$error ? false : null"
                :date-format-options="{
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                }"
                label-prev-year="hidden"
                label-next-year="hidden"
              >
              </b-form-datepicker>
              <small
                class="form-text text-danger"
                v-if="$v.formData.date3.$error"
              >
                必須項目です
              </small>
            </b-form-group>
          </b-col>

        </b-form-row>
        <b-form-row>
          <b-col offset-md="4" offset-lg="3">
            <b-form-checkbox v-model="formData.dateFree" size="lg"
              >上記希望にに係わらず、なるべく早く工事希望</b-form-checkbox
            >
          </b-col>
        </b-form-row>

        <b-form-group
          id="fieldset-orderNum"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="ご注文番号"
          label-size="lg"
          label-for="input-orderNum"
          class="mt-3"
        >
          <b-form-input
            id="input-orderNum"
            v-model="formData.orderNum"
            class="shadow-inset"
            inputmode="numeric"
            size="lg"
          ></b-form-input>
          <span class="mt-1 text-muted d-block">メールに記載している注文番号を入力してください</span>
        </b-form-group>

        <b-form-group
          id="fieldset-other"
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="7"
          label="その他・ご要望等"
          label-size="lg"
          label-for="input-other"
          class="mt-3"
        >
          <b-form-textarea
            size="lg"
            id="input-other"
            v-model="formData.other"
            rows="3"
            max-rows="6"
            class="shadow-inset"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
      <b-col cols="10" md="8" lg="6" class="py-5">
        <b-alert :show="showError && $v.$invalid" variant="danger">
          いくつかの入力箇所に誤りがあります
        </b-alert>
        <b-button
          block
          variant="warning"
          size="lg"
          class="btn-gd"
          :disabled="nowLoading"
          @click="validate"
        >
          <b-spinner
            v-if="nowLoading"
            variant="white"
            label="Spinning"
            class="mr-2"
          ></b-spinner>
          取付依頼
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import PriceTable from "./PriceTable";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  components: {
    PriceTable,
  },
  data() {
    return {
      now: new Date(),
      offset: 10,

      formData: {
        name: null, //お名前
        kana: null, //お名前（カナ）
        zip: null,
        address1: null, //都道府県
        address2: null, //市区町村
        address3: null, //以下住所
        address4: null, //建物名(部屋番号)
        tel: null, //電話番号
        time: "いつでも", //電話連絡ご希望時間帯
        email: null, //メール
        //訪問日程
        date1: null, //第一希望
        date2: null, //第二希望
        date3: null, //第三希望
        dateFree: null, //上記希望にに係わらず、なるべく早く工事希望
        orderNum: null, //ご注文番号

        other: null, //その他ご要望等
      },
      showError: false,
      nowLoading: false,
      inputFlag: false, //カナ入力の確認
    };
  },
  validations() {
    console.log(this.formData.dateFree);
    if (this.formData.dateFree) {
      return {
        formData: {
          kana: {
            required,
          },
          tel: {
            required,
          },
          email: {
            required,
            email,
          },
          date1: {},
          date2: {},
          date3: {},
        },
      };
    } else {
      return {
        formData: {
          kana: {
            required,
          },
          tel: {
            required,
          },
          email: {
            required,
            email,
          },
          date1: {
            required,
          },
          date2: {
            required,
          },
          date3: {
            required,
          },
        },
      };
    }
  },
  watch: {
    "formData.kana": function (newValue) {
      if (newValue && !this.inputFlag) {
        this.inputFlag = true;
        console.log("google:カナ入力開始");
        // this.$gtag.event("入力", {
        //   event_category: "テキスト入力",
        //   event_label: "依頼フォーム",
        //   value: "カナ入力開始",
        // });
      }
    },
  },
  mounted() {
    console.log('priceForMail', this.priceForMail);
    if (this.$gtag) {
      this.$gtag.event("画面遷移", {
        event_category: "取付依頼フォーム",
        event_label: "取付依頼フォーム",
        value: "取付依頼フォーム表示",
      });
    }
    //最上部から表示させる
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }, 100);
    // シミュレーション結果が無い場合はトップページへリダイレクト
    if (!this.zip) {
      this.$router.push({ name: "page1" });
    }
    this.formData.zip = this.zip;
    this.formData.address1 = this.address.address1;
    this.formData.address2 = this.address.address2;
    this.formData.address3 = this.address.address3;
  },
  computed: {
    ...mapState({
      address() {
        return this.$store.getters.address;
      },
      zip() {
        return this.$store.getters.zip;
      },
      calendar() {
        return this.$store.getters.calendar;
      },
      priceDetail() {
        return this.$store.getters.priceDetail;
      },
      priceForMail() {
        return this.$store.getters.priceForMail;
      },
    }),
  },
  methods: {
    notAllowedDates1(ymd, date) {
      // console.log(ymd, date);
      //受付停止
      if (this.formData.stop) {
        return true;
      }
      // return val !== this.formData.date2;
      let dVal = new Date(date);
      if (dVal.getTime() < this.now.getTime()) {
        // console.log("過去 notAllowd");
        return true;
      }
      //第2希望日
      if (ymd === this.formData.date2) {
        // console.log("第二希望 notAllowd");
        return true;
      }
      //第3希望日
      if (ymd === this.formData.date3) {
        // console.log("第二希望 notAllowd");
        return true;
      }

      //許可された日
      // console.log('this.allowed', this.calendar.allowed)
      for (const i in this.calendar.allowed) {
        if (ymd === this.calendar.allowed[i]) {
          console.log("許可 allow");
          return false;
        }
      }
      //許可されない日
      for (const i in this.calendar.notAllowed) {
        if (ymd === this.calendar.notAllowed[i]) {
          console.log("許可されない notAllowd");
          return true;
        }
      }
      //設定日より後
      let dStartDay = new Date(this.now);
      dStartDay.setDate(dStartDay.getDate() + this.calendar.offset - 1);
      // console.log(dVal.getTime() < dStartDay.getTime());
      return dVal.getTime() < dStartDay.getTime();
    },
    //第二希望に第一希望が選択出来ないように
    notAllowedDates2(ymd, date) {
      //受付停止
      if (this.formData.stop) {
        return true;
      }
      let dVal = new Date(date);
      //今日より未来であること
      if (dVal.getTime() < this.now.getTime()) {
        return true;
      }
      //第1希望日
      if (ymd === this.formData.date1) {
        return true;
      }
      //第3希望日
      if (ymd === this.formData.date3) {
        return true;
      }
      //許可された日
      for (const i in this.calendar.allowed) {
        if (ymd === this.calendar.allowed[i]) {
          return false;
        }
      }
      //許可されない日
      for (const i in this.calendar.notAllowed) {
        if (ymd === this.calendar.notAllowed[i]) {
          return true;
        }
      }
      //設定日より後
      let dStartDay = new Date(this.now);
      dStartDay.setDate(dStartDay.getDate() + this.calendar.offset - 1);
      return dVal.getTime() < dStartDay.getTime();
    },
    //第三希望に第一希望が選択出来ないように
    notAllowedDates3(ymd, date) {
      //受付停止
      if (this.formData.stop) {
        return true;
      }
      let dVal = new Date(date);
      //今日より未来であること
      if (dVal.getTime() < this.now.getTime()) {
        return true;
      }
      //第1希望日
      if (ymd === this.formData.date1) {
        return true;
      }
      //第2希望日
      if (ymd === this.formData.date2) {
        return true;
      }
      //許可された日
      for (const i in this.calendar.allowed) {
        if (ymd === this.calendar.allowed[i]) {
          return false;
        }
      }
      //許可されない日
      for (const i in this.calendar.notAllowed) {
        if (ymd === this.calendar.notAllowed[i]) {
          return true;
        }
      }
      //設定日より後
      let dStartDay = new Date(this.now);
      dStartDay.setDate(dStartDay.getDate() + this.calendar.offset - 1);
      return dVal.getTime() < dStartDay.getTime();
    },
    validate() {
      this.$v.formData.$touch();
      if (this.$v.$invalid) {
        this.showError = true;
        return;
      }
      this.sendMail();
    },
    // メール送信
    sendMail() {
      // console.log("POST");
      const url = "functions/main.php";
      let formData = JSON.stringify(this.formData); //文字列に

      // let estimates = JSON.stringify(this.priceDetail); //文字列に
      let estimates = JSON.stringify(this.priceForMail); //文字列に

      let params = new URLSearchParams();
      params.append("data", formData);
      params.append("estimates", estimates);
      // console.log('formData', formData);
      // console.log('estimates', estimates);
      this.nowLoading = true;
      this.axios
        .post(url, params)
        .then((res) => {
          console.log("mail sent!", res.data);
          this.nowLoading = false;
          this.$router.push({ name: "page3" });
        })
        .catch((err) => {
          this.nowLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
